<template>
  <account-modal class="profile-customer-account-number-status-modal">
    <template slot="heading">
      <div>Change status for IBAN</div>
    </template>

    <template slot="content">
      <v-select
        id="account-number-status"
        v-model="form.status"
        :items="statusOptions"
        item-text="name"
        item-value="value"
        label="Status"
        :error-messages="getValidationErrorMessage('status')"
      />

      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PROFILE_CUSTOMER_UPDATE } from '@/events/profileCustomers'

  // Mixins
  import form from '@/mixins/form'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ProfileCustomerApi from '@/services/Api/ProfileCustomerApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ProfileCustomerAccountNumberStatusModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        profileCustomerSetAccountNumberStatus: new ApiRequest(ProfileCustomerApi.setAccountNumberStatus),
        form: {
          status: null
        }
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      account () {
        return this.modal.data.account
      },
      accountId () {
        return this.modal.data.accountId
      },
      accountNumber () {
        return this.account.accountNumber
      },
      customerId () {
        return this.modal.data.customerId
      },
      statusOptions () {
        return this.modal.data.options
      },
      loading () {
        return this.profileCustomerSetAccountNumberStatus.loading
      },
      error () {
        return this.profileCustomerSetAccountNumberStatus.error
      }
    },
    mounted () {
      this.form.status = this.account?.status ?? null
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        if (this.form.status === this.account.status) {
          this.closeModal()
          return
        }
        this.profileCustomerSetAccountNumberStatus
          .execute(
            this.customerId,
            {
              accountNumber: this.accountNumber,
              status: this.form.status
            }
          )
          .then(this.successHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      successHandler () {
        this.$eventHub.$emit(EVENT_PROFILE_CUSTOMER_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account Number status has been successfully changed.' }
          })
        }, 100)
      }
    }
  }
</script>
